import { navigation } from "./Public/navigation";
import { subnav } from "./Public/subnav";
import { tracking } from "./Public/tacking";

function init() {
	tracking();
	navigation();
	subnav();

	if (window.hasOwnProperty("ScrollReveal")) {
		ScrollReveal().reveal("[data-reveal]", {
			delay: 100,
		});
	}
}

window.addEventListener("DOMContentLoaded", init);
